import { createAction } from '@reduxjs/toolkit';

import * as ActionTypes from './actionTypes';

export const loadRefunds = createAction<string>(ActionTypes.LOAD_REFUNDS.BASE);
